/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1455
 */

module.exports = function (e, t) {
  var n = -1
  var /* [auto-meaningful-name] */e$length = e.length
  for (t || (t = Array(e$length)); ++n < e$length;) {
    t[n] = e[n]
  }
  return t
}
